import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { HealthTechnologyType, UserRole } from '../model/user.model';
import { SnackbarService } from '../services/snackbar.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
    private readonly snackbarService: SnackbarService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {

    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/area-restrita-login']);
      return of(false);
    }

    const allowedRoles = route.data['roles'] as UserRole[] | undefined;
    const userRole = this.authService.getRole();
    const userTechologies: HealthTechnologyType[] = this.authService.getTechnologies();
    const allowedTechologies = route.data['techologies'] as HealthTechnologyType[] | undefined;

    if (!allowedRoles || allowedRoles.length === 0) {
      return of(true);
    }

    if (userRole && allowedRoles.includes(userRole)) {
      if (userRole === UserRole.HEALTH_ANALYST) {
        if (!allowedTechologies || allowedTechologies.length === 0) {
          return of(true);
        }

        if (userTechologies && allowedTechologies.some((tech) => userTechologies.includes(tech))) {
          return of(true);
        }
        
        this.router.navigate(['/area-restrita/administrativo']);
        this.notify('Área restrita. Acesso não disponível para o perfil.', 'error');
        return of(false);
      }
      return of(true);
    }

    this.router.navigate(['/area-restrita/administrativo']);
    this.notify(
      'Área restrita. Acesso não disponível para o perfil.',
      'error'
    );
    return of(false);
  }

  notify(
    text: string,
    type: 'success' | 'error' | 'info' | 'warn' = 'info'
  ) {
    this.snackbarService.show(text, 'X', 5000, type);
  }
}